<template>
  <div v-if="renderPopup" id="map-popup-container">
    <div id="map-popup-content" class="storelocater-col-md-12 stlc-marker-pointer">
      <p class="rfp-storelocator-list-header rfp-storelocator-list-001">{{ location.Name }}</p>
      <p v-if="location.Address1 != null" class="stlc_list_address1">{{ location.Address1 }}</p>
      <p v-if="location.Address2 != null" class="stlc_list_address2">{{ location.Address2 }}</p>
      <p v-if="location.Address3 != null" class="stlc_list_address3">{{ location.Address3 }}</p>
      <p v-if="location.City != null || location.State != null">
        <span v-if="location.City != null">{{ location.City }}</span>
        <span v-if="location.State != null">, {{ location.State }}</span>
      </p>
      <p v-if="location.Country != null">
        <span>{{ location.Country }}</span>
      </p>
      <p v-if="location.PostalCode">
        <span>{{ location.PostalCode }}</span>
      </p>
      <p v-if="location.WorkingHours != null" class="pt10">{{ location.WorkingHours }}</p>
      <a
        v-if="location.Website != null"
        id="stlc_book_saloon_lnk"
        class="stlc_color_blue"
        target="_blank"
        :href="location.Website"
        @click="dataLayerTagging('rfpTaggingBookSaloon', location.Name)"
        >{{ getWebsiteBaseData(location.Website) }}</a
      >
      <p>
        <a
          v-if="location.PhoneNumber != null"
          id="stlc_call_store_lnk"
          class="rfp-stlc-storelist-phonenumber-txt"
          :href="`tel:${location.PhoneNumber}`"
          @click="dataLayerTagging('rfpTaggingCallStore', location.Name)"
          >{{ location.PhoneNumber }}</a
        >
      </p>
      <div class="rfp_social_links">
        <p class="stlc_icon_list_container">
          <a
            v-for="(snItem, index) in getSocialLinks()"
            :key="'sn_' + index"
            class="stlc_popup_icon_item"
            target="_blank"
            :href="snItem.Url"
            :title="snItem.SocialNetwork.Name"
          >
            <img
              v-if="snItem.SocialNetwork.LinkIconUrl"
              :alt="snItem.SocialNetwork.Name"
              :src="snItem.SocialNetwork.LinkIconUrl"
            />
            <template
              v-if="snItem.SocialNetwork.LinkText != '' && snItem.SocialNetwork.LinkText != null"
            >
              <span>{{ snItem.SocialNetwork.LinkText }}</span>
            </template>
          </a>
        </p>
      </div>
      <template v-for="(saItem, index) in location.StoreAttributes">
        <h4
          v-if="saItem.Options && saItem.Options.length && saItem.ShowInPopup"
          :key="'sah_' + index"
        >
          {{ saItem.Name }}
        </h4>
        <div
          v-if="saItem.Options && saItem.Options.length && saItem.ShowInPopup"
          :key="'sab_' + index"
          class="rfp_store_attrs"
        >
          <p class="stlc_icon_list_container">
            <template v-for="(optionItem, optionIndex) in saItem.Options">
              <component
                :is="
                  optionItem.AttributeUrl !== '' && optionItem.AttributeUrl !== null ? 'a' : 'span'
                "
                v-if="optionItem"
                :key="'o_' + optionIndex"
                class="stlc_popup_icon_item"
                target="_blank"
                :href="optionItem.AttributeUrl"
                :title="optionItem.Name"
              >
                <img
                  v-if="optionItem.AttributeIconUrl"
                  :alt="optionItem.Name"
                  :src="optionItem.AttributeIconUrl"
                />
                <template v-if="optionItem.AttributeText != '' && optionItem.AttributeText != null">
                  <span>{{ optionItem.AttributeText }}</span>
                </template>
              </component>
            </template>
          </p>
        </div>
      </template>
      <p v-if="distanceEnabled && location.Distance != null" class="rfp-stlc-distance-type">
        <span>{{ location.Distance }}</span>
        <span>{{ distanceType }}</span>
      </p>
      <a
        v-if="!hideGetDirectionLink"
        id="stlc_get_directions_lnk"
        :aria-label="localizedAriaLabel"
        class="stlc_getDirection rfp-stlc-getdirection"
        target="_blank"
        :href="`https://google.com/maps?q=${location.Latitude},${location.Longitude}`"
        @click="dataLayerTagging('rfpTaggingGetDirections', location.Name)"
        >{{ getDirections }}</a
      >
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-storelocator-map-popup',
  props: {
    location: {
      type: Object,
      required: true,
    },
    distanceEnabled: {
      type: Boolean,
      required: true,
    },
    renderPopup: {
      type: Boolean,
      required: false,
      default: false,
    },
    distanceType: {
      type: String,
      required: true,
      default: '',
    },
    hideGetDirectionLink: {
      type: Boolean,
      required: true,
    },
    getDirections: {
      type: String,
      required: false,
      default: '',
    },
    getDirectionAriaLabel: {
      type: String,
      default: 'Get directions to [location]',
    },
  },
  computed: {
    socialIconsLineBreaks() {
      if (this.location.SocialNetworkLinks && this.location.SocialNetworkLinks.length) {
        return this.location.SocialNetworkLinks.some(
          (l) => l.SocialNetwork.LinkText != '' && l.SocialNetwork.LinkText != null,
        );
      }

      return false;
    },
    localizedAriaLabel() {
      return this.getDirectionAriaLabel.replace('[location]', this.location.Name);
    },
  },
  updated() {
    eventBus.emit('mapPopupUpdated');
  },
  methods: {
    doInsertLineBreaksForAttributes(storeAttributeOptions) {
      if (storeAttributeOptions && storeAttributeOptions.length) {
        return storeAttributeOptions.some((a) => a.AttributeText != '' && a.AttributeText != null);
      }

      return false;
    },
    getWebsiteBaseData(urls) {
      return new URL(urls).origin;
    },
    dataLayerTagging(eventName, eventParams) {
      eventBus.emit(eventName, eventParams);
    },
    getSocialLinks() {
      if (!this.location || !this.location.SocialNetworkLinks) {
        return [];
      }

      return this.location.SocialNetworkLinks.filter(
        (snItem) =>
          snItem != null &&
          snItem.Url !== '' &&
          snItem.Url !== null &&
          snItem.SocialNetwork &&
          snItem.SocialNetwork.ShowInPopup,
      );
    },
  },
};
</script>
